import axios from './index';

export const getReportsDateRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    unitTimespan,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/admins/reports/get/gw-request-trends/section-date/${issuerID || '-'}/${
      apiAccessKeyID || '-'
    }/${userID || '-'}/${routeCategoryID || '-'}/${routeID || '-'}/${
      unitTimespan || '86400'
    }/${from || '-'}/${to || '-'}`
  );
};

export const getIssuerReportsDateRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    unitTimespan,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/issuer-staffs/reports/get/issuer/gw-request-trends/section-date/${
      apiAccessKeyID || '-'
    }/${userID || '-'}/${routeCategoryID || '-'}/${routeID || '-'}/${
      unitTimespan || '86400'
    }/${from || '-'}/${to || '-'}`
  );
};

export const getReportsIssuerRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/admins/reports/get/gw-request-trends/section-issuer/${
      issuerID || '-'
    }/${apiAccessKeyID || '-'}/${userID || '-'}/${routeCategoryID || '-'}/${
      routeID || '-'
    }/${from || '-'}/${to || '-'}`
  );
};

export const getReportsAccessKeyRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/admins/reports/get/gw-request-trends/section-api-access-key/${
      issuerID || '-'
    }/${apiAccessKeyID || '-'}/${userID || '-'}/${routeCategoryID || '-'}/${
      routeID || '-'
    }/${from || '-'}/${to || '-'}`
  );
};

export const getIssuerReportsAccessKeyRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/issuer-staffs/reports/get/issuer/gw-request-trends/section-api-access-key/${
      apiAccessKeyID || '-'
    }/${userID || '-'}/${routeCategoryID || '-'}/${routeID || '-'}/${
      from || '-'
    }/${to || '-'}`
  );
};

export const getReportsRouteRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/admins/reports/get/gw-request-trends/section-route/${issuerID || '-'}/${
      apiAccessKeyID || '-'
    }/${userID || '-'}/${routeCategoryID || '-'}/${routeID || '-'}/${
      from || '-'
    }/${to || '-'}`
  );
};

export const getIssuerReportsRouteRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/issuer-staffs/reports/get/issuer/gw-request-trends/section-route/${
      apiAccessKeyID || '-'
    }/${userID || '-'}/${routeCategoryID || '-'}/${routeID || '-'}/${
      from || '-'
    }/${to || '-'}`
  );
};

export const getReportsRouteCategoryRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/admins/reports/get/gw-request-trends/section-route-category/${
      issuerID || '-'
    }/${apiAccessKeyID || '-'}/${userID || '-'}/${routeCategoryID || '-'}/${
      routeID || '-'
    }/${from || '-'}/${to || '-'}`
  );
};

export const getIssuerReportsRouteCategoryRequest = (filterObj = {}) => {
  const {
    issuerID,
    apiAccessKeyID,
    userID,
    routeCategoryID,
    routeID,
    from,
    to
  } = filterObj;
  return axios.get(
    `v1/issuer-staffs/reports/get/issuer/gw-request-trends/section-route-category/${
      apiAccessKeyID || '-'
    }/${userID || '-'}/${routeCategoryID || '-'}/${routeID || '-'}/${
      from || '-'
    }/${to || '-'}`
  );
};
